import React from 'react';

// Placeholder image URL - replace with actual image paths or a default placeholder
const PLACEHOLDER_IMAGE_URL = "https://via.placeholder.com/400x225.png?text=TERAPLUS+Konten";

const ContentCard = ({
  imageSrc,
  title = "Judul Konten Default", // "Lorem ipsum dolor sit amet consectetur."
  category = "Kategori", 

  onViewClick, 
}) => {
  const effectiveImageSrc = imageSrc || PLACEHOLDER_IMAGE_URL;

  return (
    <div 
      className="group bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full border border-gray-100 hover:shadow-xl hover:shadow-blue-500/10 transition-all duration-300 transform hover:-translate-y-1"
      onClick={onViewClick}
      style={{ cursor: 'pointer' }}
    >
      <div className="relative overflow-hidden">
        <img 
          src={effectiveImageSrc} 
          alt={title} 
          className="w-full h-40 sm:h-44 object-cover bg-gray-200 group-hover:scale-105 transition-transform duration-300" 
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-3 left-3">
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
            {category}
          </span>
        </div>
      </div>
      <div className="p-5 flex flex-col flex-grow">
        <h3 className="text-base font-semibold text-gray-900 mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors duration-200">
          {title}
        </h3>
        <div className="mt-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-sm text-gray-500">
              <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
              </svg>
              Lihat Kursus
            </div>
            <svg className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
